import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import { Grid, Stack, Toolbar, Typography } from "@mui/material";
import logo from "./../images/logo.png";
import "./../header/Header.css";
import { ComBtn } from "../commonFields/ComBtn";
import useMediaQuery from "@mui/material/useMediaQuery";
import CallIcon from "@mui/icons-material/Call";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";


const StaticHearder = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const bMediaQuery = useMediaQuery("(max-width:360px)");
  const aMediaQuery = useMediaQuery("(min-width: 365px) and (max-width: 450px)");

  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function

  const handleClick = () => {
    const footerElement = document.getElementById('contactInfo'); // Get the footer element by ID
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the footer element
    }
  };

  const heading = {
    fontWeight: 800,
    fontFamily: "EB Garamond",
    fontSize: aMediaQuery ? "23px" : vMediaQuery ? '18px' : "34px",
    marginLeft: aMediaQuery ? "8px" : vMediaQuery ? "4px" : "0px",
    padding: bMediaQuery ? '4px 10px' : '',
    paddingX: aMediaQuery ? '10px' :vMediaQuery ? '14px':'',
    backgroundImage: "linear-gradient(5deg, #357ec7, green)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
  };

  const appbar = {
    top: 0, // Position at the top of the viewport
    zIndex: 1000, // Ensure it's above other content
    boxShadow: 2,
    background: "linear-gradient(2deg,#acd3fa, #e1f7e7)",
    padding: vMediaQuery ? "2px" : "",
    display: isScrolled ? "block" : "none",
  };

  const logoAction = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  useEffect(() => {
    let scrollTimer = null;

    const handleScroll = () => {
      clearTimeout(scrollTimer); // Clear any existing timer

      scrollTimer = setTimeout(() => {
        if (window.scrollY > 0) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }, 500); // Set the delay in milliseconds
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimer); // Clear the timer on unmount
    };
  }, []);

  return (
    <>
      <AppBar
        position="fixed" // Set position to fixed
        sx={appbar}
      >
        <Toolbar>
          <Grid container>
            <Grid item xs={2} md={3} lg={3}>
              <div className="logo-contanier">
                <img className="logonav" src={logo} alt="Logo" title="GDR Consultancy Services" onClick={logoAction} />
              </div>
            </Grid>
            <Grid
              item
              xs={8}
              md={6}
              lg={6}
              sx={{ padding: vMediaQuery ? "" : "20px" }}
            >
              <div style={{ display: 'flex !important', textAlign: "center !important", justifyContent: 'center !important' }}>
                <Typography variant="h4" sx={heading}>
                  GDR Consultancy Services
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2} md={3} lg={3}>
              <Stack
                direction={"row"}
                spacing={2}
                sx={{
                  justifyContent: vMediaQuery ? "center" : "flex-end",
                  padding: vMediaQuery ? "0px" : "20px 40px",
                  marginLeft:aMediaQuery ? '12px' : "10px",
                  marginTop: aMediaQuery ? '12px' : "10px"
                }}
              >
                {!vMediaQuery &&
                  <ComBtn className={"btn"} onClick={handleClick} text={"Contact Us"} />
                }
                {vMediaQuery && (
                  <Avatar sx={{ width: 32, height: 32 }}>
                    <CallIcon onClick={handleClick}
                      sx={{
                        background: "green",
                        color: "#f0f4f5",
                        padding: "8px",
                      }}
                    />
                  </Avatar>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default StaticHearder;
